// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__hIXZO","col":"Table_col__1tADX","fulfillmentStatus":"Table_fulfillmentStatus__1p8uG","emailCol":"Table_emailCol__3O5gS"};